import { orderTypeConstants, orderStatusConstants } from "constants/order";
import { generateUUID } from "helpers/uuid";
import {
  parseDateOfService,
  convertToUTC,
} from "pages/CreateOrder/utils/helpers";
import { FieldValues } from "react-hook-form";
import { IBillingCode } from "types/BillingCode";
import { IDirectPayLinkPublicConfig } from "types/DirectPayLink.d";
import { IOrderCreateRequest } from "types/Order/Order";

export const mapFormToRequestBody = (
  props: FieldValues,
  accountId: string,
  billingCode: IBillingCode | undefined,
  originalAmountInCents: number,
  discountedAmountInCents: number,
  linkId?: string,
  linkConfig?: IDirectPayLinkPublicConfig | null,
  captchaToken?: string
) => {
  // Only use the account number from the form, don't auto-generate
  const accountNumber = props.accountNumber || null;
  return {
    accountId,
    accountNumber,
    amountInCents: originalAmountInCents,
    benefitDetails: null,
    customText: null,
    dateOfService: parseDateOfService(props),
    gfeQuoteId: null,
    orderAttemptNumber: 0,
    orderId: undefined,
    orderType: orderTypeConstants.PATIENT_RESPONSIBILITY,
    outreachStopped: true,
    patient: {
      lastName: props.lastName,
      firstName: props.firstName,
      dateOfBirth: props.dateOfBirth?.length
        ? convertToUTC(props.dateOfBirth)
        : convertToUTC("01/01/1900"),
      email: undefined,
      phoneNumber: props.phoneNumber || undefined,
      preferredContactMethod: "Phone",
      patientBenefits: { isSubscriberPatient: undefined, memberID: undefined },
      secondaryPatientBenefits: null,
    },
    patientBenefits: null,
    payerId: null,
    paymentPlanDuration: 6,
    paymentPlanEnabled: false,
    paymentPlanMinDownPaymentFlat: null,
    paymentPlanMinDownPaymentPercent: 50,
    providerDistributionLogic: null,
    pverifyResponseId: undefined,
    secondaryBenefitDetails: null,
    secondaryPatientBenefits: null,
    secondaryPayerId: null,
    secondaryPverifyResponseId: undefined,
    serviceDetails: {
      patientResponsibilityEstimateAmountInCents: discountedAmountInCents,
      procedures: [
        {
          code: billingCode?.name || linkConfig?.cptCode || "G0463",
          cptDescription:
            billingCode?.description || linkConfig?.cptDescription || "",
        },
      ],
      totalInsuranceAllowableInCents: null,
    },
    status: orderStatusConstants.SENT_TO_PATIENT,
    isCreatedWithDirectPay: true,
    directPayLinkId: linkId || undefined,
    captchaToken: captchaToken || undefined,
    directPayProviderId: props.providerId || undefined,
  } as unknown as IOrderCreateRequest;
};
